import React from 'react'
import PropTypes from 'prop-types';
import CloseIcon from 'images/icons/x-icon.inline.svg';
import { navigate } from 'gatsby'
import APISpec from 'components/APISpec/APISpec.component';
import Button from 'components/Button/Button.component';
import Modal from 'react-modal';
import { useLocation } from '@reach/router';
import {apiBtnWrap, dialogOverlay, dialogContent} from 'components/APISpec/stoplightModal-styles.module.scss';



function StoplightModal({ fileName, pageVersion = null }){

    const location = useLocation();

    const urlParams = new URLSearchParams(location.search)

    const handleOpen = () => {
      urlParams.set('open-api', true)
      navigate(`${location.pathname}?${urlParams}`)
    }

    const handleClose = () => { 
        urlParams.set('open-api', false)
        navigate(location.pathname)
    };

    const openParam = urlParams.get('open-api')

    return (
        <> 
          <span className={`${apiBtnWrap} stoplightbtn`}>
            <Button
              handleClick={handleOpen}
              color="var( --lw-gradient)"
              textColor="#ffffff"
              text="View API specification"
              style={{border: '30px solid red'}}
            />
          </span>
            <Modal
              aria-labelledby='modal-title'
              isOpen={openParam}
              onRequestClose={handleClose}
              overlayClassName={dialogOverlay}
              className={dialogContent}
            >
              <div className="stoplight-modal-wrap" style={{opacity:'0'}}>
                  <div className="close-banner">
                    <p id="modal-title">API Details</p>
                    <button type="button" aria-label="close modal" tabIndex="0" onClick={() => handleClose()}>
                      <CloseIcon />
                    </button>
                  </div>
                  <APISpec
                      pageVersion={pageVersion}
                      apiFileName={fileName}
                    />
              </div>
            </Modal>
  </>
    )
}

StoplightModal.propTypes = {
    fileName: PropTypes.string.isRequired,
    pageVersion: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array
    ])
  };

export default StoplightModal
